import {
  SideLayoutArgs,
  SideLayoutType,
  SideOpenDirectionInput,
} from "./NavbarMenuItemSubmenu.types";

function shouldOpenToRight({
  availableLeft,
  availableRight,
  defaultOpenToRight,
  isLastItem,
  submenuWidth,
}: SideOpenDirectionInput): boolean {
  const canOpenRight = availableRight >= submenuWidth;
  const canOpenLeft = availableLeft >= submenuWidth;

  if (defaultOpenToRight) {
    if (!canOpenRight && canOpenLeft) return false;

    if (!canOpenRight && !canOpenLeft) {
      return availableRight === availableLeft
        ? !isLastItem
        : availableRight > availableLeft;
    }

    return true;
  }

  if (!canOpenLeft && canOpenRight) return true;

  if (!canOpenLeft && !canOpenRight) {
    return availableRight === availableLeft
      ? isLastItem
      : availableRight > availableLeft;
  }

  return false;
}

function getSideLayout({
  anchorLeft,
  anchorRight,
  isLastItem,
  submenuWidth,
  textDirection,
  top,
  viewportHeight,
  viewportWidth,
}: SideLayoutArgs): SideLayoutType {
  const availableRight = viewportWidth - anchorRight;
  const availableLeft = anchorLeft;

  const openToRight = shouldOpenToRight({
    availableLeft,
    availableRight,
    defaultOpenToRight: textDirection === "ltr",
    isLastItem,
    submenuWidth,
  });

  return {
    left: openToRight ? anchorRight : null,
    maxHeight: Math.max(viewportHeight - top, 0),
    right: openToRight ? null : viewportWidth - anchorLeft,
    top,
  };
}

export { getSideLayout };
